/**
 * Methods for updating element states
 * Can be used on buttons, but can be used on any html element
 * */

/**
 *
 * @param {HtmlElement} element (required) - The button to update
 * @param {('loading'|'success'|'error')} state (required) - The state to set the button to
 * @param {string} message (optional) - Message to show alongside the button
 */

function updateElementState(element, state, message) {
  if (!element) {
    return;
  }

  if (state == 'loading') {
    element.classList.add('loading');
    return;
  }

  element.classList.remove('loading');
  element.classList.add(`${state}`);
  if (message) {
    element.setAttribute('message', message);

    setTimeout(() => {
      element.removeAttribute('message');
    }, 3000);
  }

  setTimeout(() => {
    element.classList.remove(`${state}`);
  }, 3000);
}

export { updateElementState };
